import { Tag, type TableColumnsType } from 'antd';
import { ZONE_KIND_COLORS, type ZoneKindColor } from '@chukua/common';
import { ZoneKindSwatch } from '../../../../../shared/components/ZoneKindSwatch';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { ZoneKind } from '../../../reference-data.api';

interface BuildZoneKindColumnsArgs {
  onEdit: (row: ZoneKind) => void;
  onDeactivate: (row: ZoneKind) => Promise<void>;
  onReactivate: (row: ZoneKind) => Promise<void>;
}

export function buildZoneKindColumns({ onEdit, onDeactivate, onReactivate }: BuildZoneKindColumnsArgs): TableColumnsType<ZoneKind> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Map colour',
      dataIndex: 'color',
      key: 'color',
      render: (color: ZoneKindColor) => (
        <span className="flex items-center gap-2">
          <ZoneKindSwatch color={color} />
          {ZONE_KIND_COLORS[color].label}
        </span>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
